import Script from 'next/script'

export default function Home() {
  return (
    <>
      <div id="root"></div>
      <Script src="/client/app.js" type="module" strategy="afterInteractive" />
    </>
  )
}
